// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Layouts
import theme from '../../../common/theme'
// Utils
import { MoneyFormatter } from '../../../common/util'

const DeclarationFormRefundContainer = styled.div`

  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-size: 18px;
  line-height: 28px;
  background-color: ${ theme.palette.light_blue };

`

export default function DeclarationFormRefund({ amount, ...props }) {

  const formattedAmount = amount ? MoneyFormatter.format(amount) : '...'

  return (
    <DeclarationFormRefundContainer>
      <span>{ formattedAmount }</span>
    </DeclarationFormRefundContainer>
  )
}
